import { Injectable } from '@angular/core'
import { Response } from '@angular/http'
import * as _ from 'lodash'
import { ToastyService, ToastyConfig, ToastOptions } from 'ng2-toasty'

import { AlertType } from './alert.type'

@Injectable()
export class AlertService {
  constructor(private toastyService: ToastyService) {}

  info(options: Object|string|Response) {
    this.show(AlertType.info, options)
  }

  success(options: Object|string|Response) {
    this.show(AlertType.success, options)
  }

  notice(options: Object|string|Response) {
    this.show(AlertType.notice, options)
  }

  warning(options: Object|string|Response) {
    this.show(AlertType.warning, options)
  }

  error(options: Object|string|Response) {
    this.show(AlertType.error, options)
  }


  private show(type: AlertType, options: Object|string|Response) {
    try {
      let typeName = AlertType[type]
      let toastyOptions
      if (options.constructor == Response) {
        let msg
        let data = options['json']()
        if (_.isObject(data) && data['error_description']) {
          msg = data['error_description']
        } else {
          msg = `${options['status']} - ${options['statusText']}`
        }
        toastyOptions = <ToastOptions>{title: null, msg: msg}
      } else if (_.isError(options)) {
        toastyOptions = <ToastOptions>{title: null, msg: options.toString()}
      } else if (_.isObject(options)) {
        toastyOptions = <ToastOptions>options
      } else {
        toastyOptions = <ToastOptions>{title: null, msg: options}
      }
      this.toastyService[typeName](toastyOptions)
    } catch (e) {
      console.error('Unexpected format data', options)
      throw new Error(`Unexpected format data: ${ options }`)
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/alert/alert.service.ts